<template>
  <div class="flex flex-col items-center justify-center w-full h-full p-4 font-sans">
    <div class="w-[420px] bg-archPanel backdrop-blur-xl border border-gray-200 rounded-2xl p-10 shadow-[0_10px_40px_rgba(0,0,0,0.1)] relative transition-all">
      <div class="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-gradient-to-br from-archGold to-[#8C6D23] rounded-xl flex items-center justify-center shadow-lg">
        <span class="text-white text-2xl">🏛️</span>
      </div>
      
      <h2 class="text-2xl text-gray-900 font-title-heavy text-center mt-6 mb-2 tracking-wide">
        {{ isLoginMode ? '欢迎回来' : '创建您的账号' }}
      </h2>
      <p class="text-gray-500 text-sm text-center mb-6">
        {{ isLoginMode ? '登录以继续使用绘真建筑大模型' : '加入绘真建筑，开启智能设计' }}
      </p>

      <div v-if="errorMsg" class="bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-2 rounded mb-6 text-center">
        {{ errorMsg }}
      </div>

      <div class="space-y-5">
        <div>
          <label class="block text-gray-600 font-bold text-sm mb-2">用户名</label>
          <input v-model="form.username" type="text" placeholder="请输入用户名" class="w-full bg-gray-50 border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:border-archGold focus:bg-white transition font-medium" />
        </div>

        <div>
          <label class="block text-gray-600 font-bold text-sm mb-2">密码</label>
          <input v-model="form.password" type="password" placeholder="请输入密码" @keyup.enter="handleSubmit" class="w-full bg-gray-50 border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:border-archGold focus:bg-white transition font-medium" />
        </div>

        <button @click="handleSubmit" :disabled="isLoading" class="w-full bg-gradient-to-r from-archGold to-[#8C6D23] text-white font-bold text-lg py-3 rounded-lg hover:shadow-lg transition disabled:opacity-50 mt-4">
          {{ isLoading ? '处理中...' : (isLoginMode ? '立即登录' : '注册账号') }}
        </button>

        <p class="text-center text-gray-500 text-sm mt-6">
          {{ isLoginMode ? '还没有账号？' : '已有账号？' }}
          <span @click="toggleMode" class="text-archGold font-bold cursor-pointer hover:underline">
            {{ isLoginMode ? '免费注册' : '直接登录' }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { loginUser } from '../store';

const router = useRouter();
const isLoginMode = ref(true);
const isLoading = ref(false);
const errorMsg = ref('');
const form = reactive({ username: '', password: '' });

const toggleMode = () => {
  isLoginMode.value = !isLoginMode.value;
  errorMsg.value = '';
  form.password = '';
};

const handleSubmit = () => {
  errorMsg.value = '';
  if (!form.username.trim() || !form.password.trim()) {
    errorMsg.value = '用户名和密码不能为空';
    return;
  }
  
  isLoading.value = true;
  
  setTimeout(() => {
    isLoading.value = false;
    const usersDB = JSON.parse(localStorage.getItem('arch_users_db') || '{}');

    if (isLoginMode.value) {
      if (usersDB[form.username] && usersDB[form.username] === form.password) {
        loginUser(form.username);
        router.push('/'); 
      } else {
        errorMsg.value = '账号未注册或密码错误';
      }
    } else {
      if (usersDB[form.username]) {
        errorMsg.value = '该用户名已被注册';
      } else {
        usersDB[form.username] = form.password;
        localStorage.setItem('arch_users_db', JSON.stringify(usersDB));
        loginUser(form.username);
        router.push('/');
      }
    }
  }, 600);
};
</script>

